<template lang="pug">
    #agentDrawer.v-card.mark-card.portal-drawer-dialog.portaldrawerDialog.drawer-flex-style(:height="windowHeight" :max-height="windowHeight" elevation='0' )
        v-form.drawer-form-flex(v-model='editAgentValid' ref='form')
            v-card-title.d-flex.justify-between-space.align-start.px-0.pb-0.drawer-header(:class="isUpsideExtension ? 'pt-3':'pt-0'" style='border-bottom: 1px solid #E8E8E8; height: 60px;')
                v-col.closeBtn()
                    v-btn.close-line.btn-none-effect(icon @click='onCloseDialog' tile :ripple="false")
                        v-icon(size='35') mdi-chevron-left
                    span.ml-2 {{$t("AGENT.EDIT_SIMPLE_AGENT")}}
                v-col(cols="auto")
                    v-btn(icon @click='onCloseDialog')
                        v-icon mdi-close
            //- 中間區塊
            div.pa-0.ma-0.mt-4.ml-4.pr-4.agent_input_area.flex-1.overflow-y-auto()
                v-row.d-flex.align-center.pt-4
                    v-col.pl-0.pb-2(cols="2")
                        v-btn(depressed icon fab @click="showAgentIconEditDialog")
                            v-img(:src="select_icon_obj.path" max-width="44")
                    v-col.px-0.pb-2(cols="10")
                        v-text-field.v-text-field_low_z-index(
                            v-model="agentdetail.agent_name" 
                            outlined
                            dense 
                            :rules="formRules.agentNameRules"
                            :placeholder= '$t("AGENT.AGENT_NAME_MSG")'
                            :disabled='file_upload_disable'
                        )
                //- 描述
                v-row.d-flex 
                    v-col.pl-0.pt-0(cols="2")
                        label.label_title {{$t('AGENT.GOAL')}}
                    v-col.px-0.pt-0(cols="10")
                        v-textarea(
                            v-model="agentdetail.goal" 
                            rows="3" 
                            no-resize outlined 
                            :disabled='file_upload_disable'
                        )
                //- 指示
                v-row.d-flex
                    v-col.pl-0.pt-1(cols="2")
                        label.label_title {{$t('AGENT.INSTRUCTION')}}
                    v-col.px-0.pt-1(cols="10")
                        v-textarea(
                            v-model="agentdetail.instruction" 
                            rows="3" 
                            no-resize 
                            outlined
                            :rules="formRules.massTextAreaRule"
                            :disabled='file_upload_disable' 
                        )
                //- 可搜尋網頁
                v-row.d-flex(v-if="$store.state.webSearchEnabled && $store.state.portalWebSearchEnabled")
                    v-col.pl-0.pt-1(cols="2")
                        label.label_title {{$t('AGENT.SEARCH_WEB')}}
                    v-col.px-0.pt-1.d-flex.align-center(cols="10")
                        label.UX-switch.mr-1
                            input(v-model='agentdetail.use_web_search' type="checkbox")
                            div(class="UX-slider round")
                        span(v-if='agentdetail.use_web_search' style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                        span(v-else style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
                //- 綁定知識庫
                v-row.d-flex()
                    v-col.pl-0.pt-1(cols="2")
                        label.label_title {{$t('AGENT.KNOWLEDGE_LIBS')}}
                    v-col.px-0.pt-1.d-flex.align-center(cols="10")
                        label.UX-switch.mr-1
                            input(v-model='agentdetail.use_knowledge_lib' type="checkbox")
                            div(class="UX-slider round")
                        span(v-if='agentdetail.use_knowledge_lib' style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                        span(v-else style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
                v-row.d-flex()
                    v-col.pl-0.pt-1(cols="2")    
                    v-col.px-0.pt-1(cols="10")
                        template(v-if="agentdetail.use_knowledge_lib")
                            v-menu(:max-width="284" content-class="agent-menu-284x328" v-model="showKnowledgePopup" :close-on-content-click="false"  min-width="320")
                                template(v-slot:activator="{ on, attrs }")
                                    .knowledge-display(
                                        v-bind="attrs"
                                        v-on="on"
                                        :class="{'knowledge-display--disabled': isUploading || !agentdetail.use_knowledge_lib,'knowledge-display--active': showKnowledgePopup}"
                                        @click.stop
                                    )
                                        span(v-if="selectedKnowledgeDisplayList.length === 0" style="color:#aaa; font-size:14px;")
                                            | {{$t("AGENT.BIND_LIB")}}
                                        .d-flex.align-center.mr-2(
                                            v-for="item in selectedKnowledgeDisplayList"
                                            :key="`selected-${item.id}`"
                                            style="flex-shrink:0;"
                                        )
                                            v-avatar(size='16' :color='getColorFromKnowledgeName(item.name)' left class="mr-1")
                                                span(style='font-size:10px; color:#000;') {{ item.name ? item.name.slice(0,1) : '' }}
                                            span(style='color:#444; font-size:13px;') {{ item.name ? item.name.split('@')[0] : '' }}
                                v-divider.my-0.agent-divider
                                v-card.no-shadow-no-radius(flat tile)
                                    //- -------- 全選列 --------
                                    div.d-flex.align-center.justify-start.ml-3(style='height:36px;' @click.stop)
                                        v-btn(
                                            style='margin-left:-6px;'
                                            icon
                                            :color="unselectAllKM ? '' : checkbox_setting"
                                            :disabled='isUploading || knowledgeList.length === 0'
                                            @click.stop='activeTriggerAllKM'
                                            :ripple="false"
                                        )
                                            v-icon(:color="unselectAllKM ? '' : checkbox_setting" size='22') {{ selectALLKMIconDesider() }}
                                        label.d-flex.label_title.justify-center(style='color:#444444; font-weight:400; font-size:14px; cursor:pointer;') {{$t('GENERAL.SELECTALL')}}
                                    v-divider.my-0.agent-divider
                                    //- -------- 知識庫清單 --------
                                    div.partial-kmlist-agent
                                        //- ======= 收藏區 =======
                                        template(v-if="!hideFavorites && knowledgeFavorites.length > 0")
                                            div.d-flex.align-center.px-3(style='height:32px;')
                                                v-icon(size='16' color='#14C6DE') mdi-star
                                                span.ml-1(style='color:#444; font-size:14px;') {{$t('PORTAL.FAVORITES')}}
                                            v-list-item-group(multiple)
                                                v-list-item.pr-0(
                                                    v-for="item in knowledgeFavorites"
                                                    :key="`fav-${item.id}`"
                                                    @click.stop
                                                    style="min-height:36px !important; padding-left:9px;"
                                                )
                                                    template(v-slot:default="{ active }")
                                                        v-list-item-action.ma-0.mr-2
                                                            v-checkbox.knowledge-favorite-checkbox.ma-0(
                                                                v-model='agentdetail.knowledges'
                                                                :value='item'
                                                                :value-comparator="(a, b) => a.id === b.id"
                                                                :disabled='isUploading'
                                                                :color="checkbox_setting"
                                                                :ripple="false"
                                                            )
                                                        v-list-item-content.pa-0(style="display:inline;")
                                                            v-avatar(size='20' max-height='20' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                                                                span(style='padding-bottom:1px;') {{ item.name ? item.name.slice(0,1) : '' }}
                                                            span(style='color:#444444; font-weight:400; font-size:14px;') {{ item.name ? item.name.split('@')[0] : '' }}
                                                        v-list-item-action.ma-0
                                                            v-btn(icon x-small @click.stop="toggleFavorite(item)")
                                                                v-icon(size='16' color='#14C6DE') mdi-star
                                            v-divider.my-0
                                        //- ======= Folder-first Checkbox 樹 =======
                                        template(v-for="node in flattenedTree")
                                            div.d-flex.align-center.tree-folder-row(
                                                v-if="node.type === 'folder'"
                                                :key="`folder-${node.id}-d${node.depth}`"
                                                :style="treeNodeStyle(node)"
                                                @click.stop
                                            )
                                                v-btn(
                                                    icon
                                                    :color="getFolderCheckState(node.id) !== 'none' ? checkbox_setting : ''"
                                                    :disabled='isUploading'
                                                    @click.stop="toggleFolderSelection(node)"
                                                    style='margin-left:-2px;'
                                                    :ripple="false"
                                                )
                                                    v-icon(:color="getFolderCheckState(node.id) !== 'none' ? checkbox_setting : ''" size='23') {{ getFolderCheckIcon(node.id) }}
                                                v-btn.pa-0(icon x-small @click.stop="toggleFolder(node.id)" style='width:18px; height:18px; min-width:18px;')
                                                    v-icon(size='14' color='#888') {{ expandedFolderIds.includes(String(node.id)) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                                                v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="20" max-width="20" contain)
                                                span.tree-node-name.ellipsis-1(style='color:#444444; font-weight:400; font-size:14px;') {{ node.name }}
                                            v-hover(v-else-if="node.type === 'library'" :key="`lib-${node.id}-d${node.depth}`" v-slot="{ hover }")
                                                div.d-flex.align-center(
                                                    :style="treeNodeStyle(node)"
                                                    @click.stop
                                                )
                                                    v-checkbox.mr-0.my-0(
                                                        style='margin-left:11px;'
                                                        v-model='agentdetail.knowledges'
                                                        :value='libraryNodeMap[node.id]'
                                                        multiple
                                                        :value-comparator="(a, b) => a.id === b.id"
                                                        :disabled='isUploading'
                                                        :color="checkbox_setting"
                                                        @click.stop
                                                        :ripple="false"
                                                    )
                                                    v-avatar.ml-3(size='20' max-height='20' :color='getColorFromKnowledgeName(node.name)' left class="mr-2")
                                                        span(style='padding-bottom:1px;') {{ node.name ? node.name.slice(0,1) : '' }}
                                                    span.tree-node-name.ellipsis-1(style='color:#444444; font-weight:400; font-size:14px;' :title="node.name") {{ node.name }}
                                                    v-spacer
                                                    v-btn(
                                                        v-show="!hideFavorites && (hover || localFavoriteIds.includes(node.id))"
                                                        icon x-small
                                                        @click.stop="toggleFavorite(node)"
                                                        style='margin-right:4px;'
                                                    )
                                                        v-icon(size='16' :color="localFavoriteIds.includes(node.id) ? '#14C6DE' : '#bbb'") {{ localFavoriteIds.includes(node.id) ? 'mdi-star' : 'mdi-star-outline' }}
                                        //- ======= 私人知識庫 =======
                                        template(v-if='privateKnowledgeList.length > 0')
                                            div.kb-section-title.ml-1(style='color:#999999; font-weight:500; font-size:12px; margin-top:8px; margin-bottom:4px;')
                                                | {{$t("PORTAL.MY_KNOWLEDGE")}}
                                            v-list-item-group(multiple)
                                                v-list-item(
                                                    v-for='item in privateKnowledgeList'
                                                    :key='`pri-${item.id}`'
                                                    style='min-height:36px !important; padding-left:11px;'
                                                    @click.stop
                                                )
                                                    v-list-item-action.ma-0.mr-2
                                                        v-checkbox.ma-0(
                                                            v-model='agentdetail.knowledges'
                                                            :value='item'
                                                            :value-comparator="(a, b) => a.id === b.id"
                                                            :disabled='isUploading'
                                                            :color="checkbox_setting"
                                                            :ripple="false"
                                                        )
                                                    v-list-item-content.pa-0(style="display: inline;")
                                                        v-avatar(size='20' max-height='20' :color='getColorFromKnowledgeName(item.name)' left class="mr-2")
                                                            span(style='padding-bottom:1px;') {{item.name ? item.name.slice(0,1) : ''}}
                                                        span(style='color:#444444; font-weight:400; font-size:14px;') {{ item.name ? item.name.split('@')[0] : '' }}
                                                    v-list-item-action.ma-0
                                                        v-hover(v-slot="{ hover }")
                                                            v-btn(icon x-small @click.stop="toggleFavorite(item)")
                                                                v-icon(size='16' :color="item.is_favorite ? '#14C6DE' : (hover ? '#bbb' : 'transparent')") {{ item.is_favorite ? 'mdi-star' : 'mdi-star-outline' }}

                //- 檔案上傳
                v-row.d-flex()
                    v-col.pl-0.pt-1(cols="2")
                        label.label_title {{$t('AGENT.FILE')}}
                    v-col.px-0.pt-1(cols="10")
                        multipleFile(
                            :uploadBtnText="'Save'"
                            :progressBtnText="'Saving...'"
                            :uploadedFiles="agentdetail.attach_document"
                            :isUploading="isUploading"
                            :accept="acceptFileTypes"
                            @saveFiles="saveFiles"
                            @showErrorDialog="showErrorDialog"
                            @editDeleteFile="editDeleteFile"
                        )
            //- 按鈕
            div.portal-drawer-footer.d-flex.justify-start.align-center.px-4.py-4.shrink-0()
                v-btn(@click="onConfirm" :disabled='isUploading || file_upload_disable'  width='115' height='30' :ripple='false' :color="file_upload_disable ? '#E0E0E0' : '#14C6DE'" outlined depressed)
                    v-progress-circular(v-if='editBtn_loading' indeterminate size='20')
                    span.d-flex.align-center(v-else)
                        span
                            v-img(src="@/assets/images/save-icon.svg" max-width="15px"  height="15px")
                        span.pl-1(
                            :style="{fontFamily: 'Segoe UI',fontWeight: 600,fontSize: '14px',color: (file_upload_disable || isUploading) ? '#E0E0E0' : '#14C6DE'}"
                        ) {{$t('GENERAL.SAVE')}}
        v-dialog(v-model='successDialog' width='360'  content-class='statusDialog')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='selectagenticondialog' max-width="300" max-height="400")
            select-agent-icon-dialog(@emitSelectAgentIconDialog='onEmitSelectAgentIconDialog' :currentIconPath='agentdetail.icon_path')
</template>

<script>
    import Vue from 'vue';
    import i18n from '/common/plugins/vue-i18n.js';
    import { mapState } from 'vuex';
    import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices"
    import KnowledgeLibraryService from "@/services/KnowledgeLibraryService"
    import selectAgentIconDialog from "@/components/GPT_Dialog/Agent/selectAgentIconDialog";
    import successDialog from "@/components/Dialog/successDialog";
    import errorDialog from "@/components/Dialog/errorDialog";
    import messageDialog from "@/components/Dialog/messageDialog";
    import multipleFile from "@/components/Common/multipleFile.vue";
    import PreferenceService from "@/services/PreferenceService";

    export default Vue.extend({
        props: {
            agentdetail: {
                type:Object,
                required: true
            },
            user_mode: {
                type: Boolean,
                required: true,
            },
            knowledgeList: {
                type: Array,
                required:true,
            },
            knowledgeListPrivate: {
                type: Array,
                required:true,
            },
            allKnowledgeColor: {
                type: Array,
                default: () => []
            },
            folderTreeOptions: {
                type: Array,
                default: () => []
            },
            hideFavorites: {
                type: Boolean,
                default: false
            },
        },
        components: {
            selectAgentIconDialog,
            successDialog,
            errorDialog,
            messageDialog,
            multipleFile,
        },
        created() {
            if (this.agentdetail && this.agentdetail.icon_path){
                this.select_icon_obj = { name: this.agentdetail.icon_path, path: this.mapping_icon_path(this.agentdetail.icon_path) }
            } else {
                this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
            }
            this.getPortalColorSetting();
        },
        data() {
            return{
                windowHeight: window.innerHeight,
                editBtn_loading: false,
                editAgentValid: true,
                upload_size: 20,
                successDialog: false,
                errorDialog: false,
                errorMessage: '',
                editAgentdetail: {},
                formRules: {
                    massTextAreaRule: [
                        (v) => !!v || i18n.t('RULE.RULE_R'),
                        (v) => /^.{0,10000}$/s.test(v) || i18n.t('RULE.RULE_10000'),
                    ],
                    agentNameRules: [
                        (v) => !!v || i18n.t('RULE.RULE_R'),
                        (v) => /^.{0,100}$/s.test(v) || i18n.t('RULE.RULE_100'),
                    ],
                },
                initialAttachement: [],
                uploadedFiles: [],
                isUploading: false,
                acceptFileTypes: '.pdf,.docx,.pptx,.jpg,.jpeg,.png',
                selectagenticondialog:false,
                select_icon_obj: { name: "default", path: require("@/assets/images/agent_icon/default.png") },
                unselectAllKM: true,
                showKnowledgePopup: false,
                expandedFolderIds: [],
                localFavoriteIds: [],
                checkbox_setting: document.documentElement.style.getPropertyValue('--checkbox_setting') || '#14C6DE',
            }
        },
        methods: {
            async getPortalColorSetting() {
                let color_setting;
                await PreferenceService.getPortalColorSetting().then((response)=>{
                    color_setting = response.data;
                    if (color_setting) {
                        this.toggle_setting = color_setting.toggle_setting;
                        this.checkbox_setting = color_setting.checkbox_setting;
                        this.confirm_knowledge_btn = color_setting.confirm_knowledge_btn;
                    } else {
                        this.toggle_setting = "#14C6DE";
                        this.checkbox_setting = "#14C6DE";
                        this.confirm_knowledge_btn = "#14C6DE";
                    }
                })
            },
            onCloseDialog(){
                this.$emit("emitCloseAgentDrawer", "editSimpleAgent", false)
            },
            validateForm(){
                if(this.$refs.form.validate()){
                    return true;
                }else{
                    return false;
                }
            },
            async onConfirm(){
                if (await this.validateForm() && !this.editBtn_loading) {
                    const maxSizeInMB = this.upload_size * 1024 * 1024;
                    this.agentdetail.attach_document.forEach(file => {
                        let file_type = '.' + file.name.split('.').pop();
                        let allow_file_type = [".pdf", "docx", ".pptx", ".jpg", ".png"];
                        if(!allow_file_type.includes(file_type)){
                            this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.TIP_8'));
                            return;
                        }
                        else if (file.size > maxSizeInMB){
                            this.showErrorDialog(i18n.t('RULE.RULE_FILE_3', {size: 20}));
                            return;
                        }
                    });
                    if(this.agentdetail.attach_document.length > 3){
                        this.showErrorDialog(i18n.t('RULE.RULE_FILE_5'));
                        this.editBtn_loading = false;
                        return;
                    }
                    this.editBtn_loading = true
                    let data;

                    const payload = {
                        agent_name: this.agentdetail.agent_name,
                        agent_config: this.agentdetail.agent_config,
                        goal: this.agentdetail.goal,
                        instruction: this.agentdetail.instruction,
                        icon_path: this.select_icon_obj.name,
                        use_web_search: this.agentdetail.use_web_search,
                        use_knowledge_lib: this.agentdetail.use_knowledge_lib,
                        knowledges: (this.agentdetail.knowledges || []).map(k => ({
                            id: k.id,
                            name: k.name
                        })),
                    };
                    if(this.user_mode){
                        await UpGPTPortalDataServices.saveUserAgentDetail(this.agentdetail.id, payload).then(response => {
                            data = response.data;
                            data.knowledges = data.linked_useragents_and_knowledge_set.map(item=> {return item.knowledge_lib});
                            this.editBtn_loading = false;
                            this.$emit("emitCloseAgentDrawer", "editSimpleAgent", true, data);
                            this.$emit("getAgentListData");
                        }).catch((response) => {
                            this.showErrorDialog(response);
                        });
                    }else{
                        await UpGPTPortalDataServices.saveAgentDetail(this.agentdetail.id, payload).then(response => {
                            data = response.data;
                            data.knowledges = data.linked_agents_and_knowledge_set.map(item=> {return item.knowledge_lib});
                            this.editBtn_loading = false;
                            this.$emit("emitCloseAgentDrawer", "editSimpleAgent", true, data);
                        }).catch((response) => {
                            this.showErrorDialog(response);
                        });
                    }
                }
            },
            showSuccessDialog() {
                this.successDialog = true;
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
            },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorDialog = false;
            },
            showAgentIconEditDialog() {
                this.selectagenticondialog = true;
            },
            onEmitSelectAgentIconDialog(icon_obj) {
                this.select_icon_obj = icon_obj;
                this.agentdetail.icon_path = this.select_icon_obj.name;
                this.selectagenticondialog = false;
            },
            async editDeleteFile(data_file){
                let data = {
                    "attach_document": data_file,
                    "is_user_agent": this.user_mode
                }
                await UpGPTPortalDataServices.editDeleteFile(this.agentdetail.id ,data);
            },
            async saveFiles(files){
                this.isUploading = true;
                let data = {
                    agent_id: this.agentdetail.id,
                    attach_document: files,
                    is_private_agent: Boolean(this.user_mode)
                }
                await UpGPTPortalDataServices.saveFiles(data)
                .then((response)=>{
                        if(response) this.isUploading = false;
                        this.agentdetail.attach_document = response.data;
                })
                .catch((error) => {
                    console.log(error)
                    this.isUploading = false;
                    if(error == 'Error: timeout of 30000ms exceeded'){
                        this.isUploading = true;
                        this.showErrorDialog(i18n.t('AGENT_FILE_ATTACHMENT.STILL_RUN'))
                    }else{
                        this.showErrorDialog(String(error))
                    }
                })
            },
            mapping_icon_path(icon_name){
                if (icon_name == 'award') {
                    return require("@/assets/images/agent_icon/award.png")
                } else if (icon_name == 'cloud'){
                    return require("@/assets/images/agent_icon/cloud.png")
                } else if (icon_name == 'construction'){
                    return require("@/assets/images/agent_icon/construction.png")
                } else if (icon_name == 'customerservice'){
                    return require("@/assets/images/agent_icon/customerservice.png")
                } else if (icon_name == 'finance'){
                    return require("@/assets/images/agent_icon/finance.png")
                } else if (icon_name == 'generate'){
                    return require("@/assets/images/agent_icon/generate.png")
                } else if (icon_name == 'humanresource'){
                    return require("@/assets/images/agent_icon/humanresource.png")
                } else if (icon_name == 'idea'){
                    return require("@/assets/images/agent_icon/idea.png")
                } else if (icon_name == 'knowledge'){
                    return require("@/assets/images/agent_icon/knowledge.png")
                } else if (icon_name == 'message'){
                    return require("@/assets/images/agent_icon/message.png")
                } else if (icon_name == 'metal'){
                    return require("@/assets/images/agent_icon/metal.png")
                } else if (icon_name == 'policy'){
                    return require("@/assets/images/agent_icon/policy.png")
                } else if (icon_name == 'questionandanswer'){
                    return require("@/assets/images/agent_icon/questionandanswer.png")
                } else if (icon_name == 'report'){
                    return require("@/assets/images/agent_icon/report.png")
                } else if (icon_name == 'robot'){
                    return require("@/assets/images/agent_icon/robot.png")
                } else if (icon_name == 'searchimage'){
                    return require("@/assets/images/agent_icon/searchimage.png")
                } else if (icon_name == 'setting'){
                    return require("@/assets/images/agent_icon/setting.png")
                } else if (icon_name == 'shopping_cart'){
                    return require("@/assets/images/agent_icon/shopping_cart.png")
                } else if (icon_name == 'speclist'){
                    return require("@/assets/images/agent_icon/speclist.png")
                } else if (icon_name == 'translate'){
                    return require("@/assets/images/agent_icon/translate.png")
                } else if (icon_name == 'conversation'){
                    return require("@/assets/images/agent_icon/conversation.png")
                } else if (icon_name == 'record'){
                    return require("@/assets/images/agent_icon/record.png")
                } else if (icon_name == 'target'){
                    return require("@/assets/images/agent_icon/target.png")
                } else if (icon_name == 'house'){
                    return require("@/assets/images/agent_icon/house.png")
                } else if (icon_name == 'land_property'){
                    return require("@/assets/images/agent_icon/land_property.png")
                } else if (icon_name == 'mail_reply'){
                    return require("@/assets/images/agent_icon/mail_reply.png")
                } else if (icon_name == 'search_web'){
                    return require("@/assets/images/agent_icon/search_web.png")
                } else {
                    return require("@/assets/images/agent_icon/default.png")
                }
            },
            // ===== 全選邏輯 =====
            selectAllKMCheck() {
                const uniqueIds = new Set([
                    ...this.knowledgeList.map(i => i.id),
                    ...this.knowledgeListPrivate.map(i => i.id),
                ])
                return uniqueIds.size > 0 && (this.agentdetail.knowledges || []).length === uniqueIds.size
            },
            selectSomeKMCheck() {
                return (this.agentdetail.knowledges || []).length > 0 && !this.selectAllKMCheck();
            },
            selectALLKMIconDesider() {
                if (this.selectAllKMCheck()) {
                    this.unselectAllKM = false;
                    return 'mdi-checkbox-marked';
                } else if (this.selectSomeKMCheck()) {
                    this.unselectAllKM = false;
                    return 'mdi-minus-box';
                } else {
                    this.unselectAllKM = true;
                    return 'mdi-checkbox-blank-outline';
                }
            },
            activeTriggerAllKM() {
                if (this.selectAllKMCheck() || this.selectSomeKMCheck()) {
                    this.agentdetail.knowledges = [];
                } else {
                    const seen = new Map()
                    ;[...this.knowledgeList, ...this.knowledgeListPrivate].forEach(item => {
                        if (!seen.has(item.id)) seen.set(item.id, item)
                    })
                    this.agentdetail.knowledges = [...seen.values()]
                }
            },
            getColorFromKnowledgeName(knowledge_name) {
                let color_data = this.allKnowledgeColor.find(item => item.name == knowledge_name);
                return color_data ? color_data.color : 'aliceBlue';
            },
            // ===== 樹狀節點 =====
            treeNodeStyle(node) {
                if (node.depth === 0) {
                    return { paddingLeft: node.type === 'folder' ? '6px' : '0', minHeight: '36px' }
                }
                const ml = (node.depth - 1) * 16 + 14
                return {
                    marginLeft: ml + 'px',
                    // borderLeft: '2px solid #e0e0e0',
                    paddingLeft: node.type === 'folder' ? '6px' : '0',
                    minHeight: '36px',
                }
            },
            toggleFolder(folderId) {
                const id = String(folderId)
                const idx = this.expandedFolderIds.indexOf(id)
                if (idx === -1) {
                    this.expandedFolderIds.push(id)
                } else {
                    this.expandedFolderIds.splice(idx, 1)
                }
            },
            getAllLibsUnderNode(node) {
                const libs = []
                const traverse = (children) => {
                    for (const child of (children || [])) {
                        if (child.type === 'library') {
                            libs.push(child)
                        } else if (child.type === 'folder') {
                            traverse(child.children || [])
                        }
                    }
                }
                traverse(node.children || [])
                return libs
            },
            getFolderCheckState(folderId) {
                const rawNode = this.findNodeInTree(this.folderTreeOptions, String(folderId))
                if (!rawNode) return 'none'
                const libs = this.getAllLibsUnderNode(rawNode)
                if (libs.length === 0) return 'none'
                const knowledges = this.agentdetail.knowledges || []
                const selectedCount = libs.filter(lib =>
                    knowledges.some(s => s.id === lib.id)
                ).length
                if (selectedCount === 0) return 'none'
                if (selectedCount === libs.length) return 'all'
                return 'some'
            },
            getFolderCheckIcon(folderId) {
                const state = this.getFolderCheckState(folderId)
                if (state === 'all') return 'mdi-checkbox-marked'
                if (state === 'some') return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },
            toggleFolderSelection(folderNode) {
                const rawNode = this.findNodeInTree(this.folderTreeOptions, String(folderNode.id))
                if (!rawNode) return
                const libs = this.getAllLibsUnderNode(rawNode)
                if (libs.length === 0) return
                const state = this.getFolderCheckState(folderNode.id)
                const knowledges = this.agentdetail.knowledges || []
                if (state === 'all') {
                    const libIds = new Set(libs.map(l => l.id))
                    this.agentdetail.knowledges = knowledges.filter(s => !libIds.has(s.id))
                } else {
                    const alreadySelectedIds = new Set(knowledges.map(s => s.id))
                    const toAdd = libs.filter(l => !alreadySelectedIds.has(l.id))
                    this.agentdetail.knowledges = [...knowledges, ...toAdd]
                }
            },
            findNodeInTree(nodes, id) {
                for (const node of (nodes || [])) {
                    if (String(node.id) === id) return node
                    if (node.type === 'folder') {
                        const found = this.findNodeInTree(node.children || [], id)
                        if (found) return found
                    }
                }
                return null
            },
            // ===== 收藏功能 =====
            _syncFavoriteState(id, isFavorite) {
                const idx = this.localFavoriteIds.indexOf(id)
                if (isFavorite && idx === -1) this.localFavoriteIds.push(id)
                else if (!isFavorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
                const original = [...this.knowledgeList, ...this.knowledgeListPrivate].find(k => k.id === id)
                if (original) this.$set(original, 'is_favorite', isFavorite)
            },
            async toggleFavorite(item) {
                const wasFavorite = this.localFavoriteIds.includes(item.id)
                const newVal = !wasFavorite
                this._syncFavoriteState(item.id, newVal)
                try {
                    if (newVal) {
                        await KnowledgeLibraryService.addFavorite(item.id)
                    } else {
                        await KnowledgeLibraryService.removeFavorite(item.id)
                    }
                } catch (e) {
                    this._syncFavoriteState(item.id, wasFavorite)
                    this.showErrorDialog(this.$t('PORTAL.FAVORITE_ERROR') || '收藏操作失敗')
                }
            },
        },
        computed :{
            ...mapState([
                'isUpsideExtension',
            ]),
            file_upload_disable(){
                let status = this.agentdetail?.upload_status  ?? "completed"
                return status == "processing";
            },
            flattenedTree() {
                const result = []
                const flatten = (nodes, depth = 0) => {
                    for (const node of (nodes || [])) {
                        result.push({ ...node, depth })
                        if (node.type === 'folder' && this.expandedFolderIds.includes(String(node.id))) {
                            flatten(node.children || [], depth + 1)
                        }
                    }
                }
                flatten(this.folderTreeOptions)
                return result
            },
            knowledgeFavorites() {
                return [...this.knowledgeList, ...this.knowledgeListPrivate]
                    .filter(item => this.localFavoriteIds.includes(item.id))
            },
            // 建立 library id → 原始 folderTreeOptions 節點的映射表
            // 確保 v-checkbox 的 :value 永遠使用穩定的物件 reference，
            // 避免 flattenedTree recompute（展開/收合資料夾）時產生新 spread 物件，
            // 觸發 Vuetify 2 的 value watcher 把 knowledges 覆蓋掉。
            libraryNodeMap() {
                const map = {}
                const traverse = (nodes) => {
                    for (const node of (nodes || [])) {
                        if (node.type === 'library') {
                            map[node.id] = node
                        } else if (node.type === 'folder') {
                            traverse(node.children || [])
                        }
                    }
                }
                traverse(this.folderTreeOptions)
                return map
            },
            selectedKnowledgeDisplayList() {
                if (!Array.isArray(this.agentdetail.knowledges) || this.agentdetail.knowledges.length === 0) {
                    return [];
                }
                const selectedIdSet = new Set(
                    this.agentdetail.knowledges.map(item => (item && item.id != null ? item.id : item))
                );
                const CombineknowledgeList = this.knowledgeList.concat(this.knowledgeListPrivate);
                return CombineknowledgeList.filter(item => selectedIdSet.has(item.id));
            },
            privateKnowledgeList() {
                return this.knowledgeListPrivate.filter(item => item);
            },
        },
        watch: {
            "agentdetail.icon_path":function(e){
                if (e){
                    this.select_icon_obj = { name: e, path: this.mapping_icon_path(e) }
                } else {
                    this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
                }
            },
            file_upload_disable(newVal) {
                this.isUploading = newVal;
            },
            knowledgeList: {
                immediate: true,
                handler(list) {
                    list.forEach(item => {
                        const idx = this.localFavoriteIds.indexOf(item.id)
                        if (item.is_favorite && idx === -1) this.localFavoriteIds.push(item.id)
                        else if (!item.is_favorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
                    })
                }
            },
            knowledgeListPrivate: {
                immediate: true,
                handler(list) {
                    list.forEach(item => {
                        const idx = this.localFavoriteIds.indexOf(item.id)
                        if (item.is_favorite && idx === -1) this.localFavoriteIds.push(item.id)
                        else if (!item.is_favorite && idx !== -1) this.localFavoriteIds.splice(idx, 1)
                    })
                }
            },
        }
    })
</script>

<style scoped>
.ellipsis-1{
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.knowledge-display {
    min-height: 36px;
    border: 1px solid #9d9d9d;
    border-radius: 6px;
    padding: 4px 8px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    background: #fff;
}
.knowledge-display:not(.knowledge-display--disabled):hover {
    border: 1px solid #0b0b0b;
    background-color: #fafafa;
}

.knowledge-display--active {
    border: 2px solid #508af0;
    background-color: #fff;
}
.knowledge-display--disabled {
    cursor: not-allowed;
    opacity: 0.65;
    background-color: #f5f5f5;
}

.kb-section-title {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 8px 0 4px 0;
}

.partial-kmlist-agent {
    max-height: 230px;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #EFEFEF;
    border-radius: 4px;
    padding: 4px 0;
}
.partial-kmlist-agent::-webkit-scrollbar {
    width: 6px;
}
.partial-kmlist-agent::-webkit-scrollbar-track {
    background: #F4F4F4 !important;
}
.partial-kmlist-agent::-webkit-scrollbar-thumb {
    background: rgba(153, 153, 153, 0.3);
    border-radius: 10px;
}
.partial-kmlist-agent::-webkit-scrollbar-thumb:hover {
    background: rgba(153, 153, 153, 0.5);
}

::v-deep .partial-kmlist-agent .v-input--selection-controls__input .v-icon {
      font-size: 20px !important;
}

.knowledge-favorite-checkbox::v-deep .v-input--selection-controls__input .v-icon {
      font-size: 20px !important;
}

.tree-folder-row {
    cursor: pointer;
}
.tree-folder-row:hover {
    background: rgba(0,0,0,0.03);
}
.tree-node-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 165px;
}

.agent-divider {
    border-color: #e8e8e8 !important;
    opacity: 1 !important;
}
.v-card.no-shadow-no-radius {
    box-shadow: none !important;
    border-radius: 0 !important;
}

::v-deep .v-list-item::before {
  display: none !important;
}
::v-deep .v-list-item .v-ripple__container {
  display: none !important;
}
</style>
